module.exports = __webpack_public_path__ + "web/img/integral_en.62d3bbf5.png";